import { Injectable } from '@angular/core';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { ITeamsApplicationConfigurationProvider } from '@nimbus-library/features/microsoft-teams/models/i-teams-application-configuration.provider';
import { ITeamsApplicationConfiguration } from '@nimbus-library/features/microsoft-teams/models/i-teams-application.configuration';

@Injectable()
export class TeamsApplicationConfigurationProvider implements ITeamsApplicationConfigurationProvider {
  public constructor(private readonly environmentConfiguration: EnvironmentConfigurationService) {}

  public getConfiguration(): ITeamsApplicationConfiguration {
    return {
      appId: this.environmentConfiguration.configurationSettings.msTeamsAppId,
    };
  }
}
